import { render, staticRenderFns } from "./taskitem.vue?vue&type=template&id=3fa97db4&scoped=true"
import script from "./taskitem.vue?vue&type=script&lang=js"
export * from "./taskitem.vue?vue&type=script&lang=js"
import style0 from "./taskitem.vue?vue&type=style&index=0&id=3fa97db4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa97db4",
  null
  
)

export default component.exports